module.exports = __webpack_public_path__ + "static/media/KITTY-101-badge.884d4023.svg";